module.exports = __webpack_public_path__ + "img/II-43.4.1cda51f7.svg";